import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";
import { getLatestUpdatedComics } from "@/utils/comic";

const tabs = ["全部", "连载中", "已完结"] as const;

export default function LatestUpdates({ activeTab, onTabChange }: {
  activeTab: string;
  onTabChange: (tab: string) => void;
}) {
  const latest = getLatestUpdatedComics(12);
  const list =
    activeTab === "全部" ? latest : latest.filter((c) => c.status === activeTab);
  const shown = list.length > 0 ? list : comics.slice(0, 6);

  return (
    <div className="w-full">
      <div className="flex items-end justify-between gap-4 mb-5">
        <div>
          <h2 className="text-lg md:text-xl font-label font-bold text-foreground-950">
            最新更新
          </h2>
          <p className="text-xs md:text-sm text-foreground-500 mt-1">
            追更不掉队，查看最新连载章节
          </p>
        </div>
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-100">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => onTabChange(tab)}
              className={`px-3 py-1.5 rounded-full text-xs md:text-sm font-label font-bold whitespace-nowrap transition-colors cursor-pointer ${
                activeTab === tab
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {shown.length === 0 ? (
        <div className="py-16 text-center text-sm text-foreground-500 rounded-lg bg-background-100 border border-dashed border-background-300">
          暂无相关内容，试试其他筛选条件
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {shown.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      )}

      <div className="mt-6 flex justify-center">
        <Link
          to="/search"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm font-label font-bold hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-add-line"></i>
          浏览更多漫画
        </Link>
      </div>
    </div>
  );
}